const OPTIONS_TYPE = {
  CTA: 'cta',
  MULTI: 'multi',
  BRANCH: 'branch',
  RANGE_INPUT: 'rangeInput',
};

export default OPTIONS_TYPE;
